import Dialog from "@/components/Dialog/Dialog";
import { supabaseHsvCrm } from "@/utils/supabaseHsvCrm";
import { useDisclosure } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useMutation } from "react-query";

function BlockCRM26HspPage() {
  const { isOpen: confirmIsOpen, onClose: onConfirmClose } = useDisclosure({ defaultIsOpen: true });
  const { isOpen: failIsOpen, onOpen: onFailOpen, onClose: onFailClose } = useDisclosure();
  const { isOpen: doneIsOpen, onOpen: onDoneOpen, onClose: onDoneClose } = useDisclosure();

  const router = useRouter();

  const { mutate: blockMutate, isLoading } = useMutation(
    async (phone: string) => {
      const { error } = await supabaseHsvCrm.from("homeshopping_crm_blocks").insert({ phone });

      if (error) throw error;
    },
    {
      onSuccess: onDoneOpen,
      onError: onFailOpen,
      onSettled: onConfirmClose,
    },
  );

  const onConfirm = () => {
    const phone = router.query.phone;
    if (typeof phone !== "string") {
      onFailOpen();
      onConfirmClose();
      return;
    }
    blockMutate(phone);
  };

  const redirectToHome = () => router.push("https://prime.goifuneral.co.kr/");

  return (
    <>
      <Dialog
        type={1}
        isOpen={confirmIsOpen}
        onClose={onConfirmClose}
        header="알림톡을 차단하시겠습니까?"
        footerProps={[
          { text: "아니요", onClick: redirectToHome },
          {
            text: isLoading ? "처리 중.." : "네",
            onClick: isLoading ? () => {} : onConfirm,
          },
        ]}
      >
        이벤트 / 프로모션 관련 메시지를 제외한
        <br />
        기가입자 대상 약관 변경 등의 주요 공지사항은
        <br />
        차단 여부와 관계 없이 발송됩니다.
      </Dialog>

      <Dialog
        type={1}
        isOpen={doneIsOpen}
        onClose={onDoneClose}
        header="차단 처리가 완료되었습니다."
        footerProps={{ text: "확인", onClick: redirectToHome }}
      >
        고이를 찾아주셔서 감사합니다.
      </Dialog>

      <Dialog
        type={1}
        isOpen={failIsOpen}
        onClose={onFailClose}
        header="차단 처리에 실패했습니다."
        footerProps={{ text: "확인", onClick: redirectToHome }}
      >
        올바른 링크인지 확인해 주세요.
      </Dialog>
    </>
  );
}

export default BlockCRM26HspPage;
